import { SharedModule } from 'src/app/shared/shared.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import * as fromSite from '../site/site.reducer';
import { SiteEffects } from './site.effects';
import { SiteSerializer } from './site.serializer';
import { SiteService } from './site.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(fromSite.FEATURE_NAME, fromSite.siteReducer),
    EffectsModule.forFeature([SiteEffects])
  ],
  providers: [
    SiteService,
    {
      provide: SiteSerializer,
      useClass: SiteSerializer
    }
  ],
  declarations: []
})
export class SiteModule {}
